import { Component, Input } from "@angular/core";
import { LocalizableString, QuestionBooleanModel } from "survey-core";
@Component({
  selector: "sv-ng-boolean-radio-item",
  templateUrl: "boolean-radio-item.component.html",
})
export class BooleanRadioItemComponent {
  @Input() question!: QuestionBooleanModel;
  @Input() value!: string | boolean;
  @Input() locText!: LocalizableString;
  constructor() {

  }
  public change() {
    if (!this.question.isInputReadOnly) {
      this.question.value = this.value;
    }
  }
}
